import { CSSProperties, HTMLAttributes } from 'react';

interface ContentRightSideStickyProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode,
    btnStyle?: CSSProperties,
}

function ContentRightSideSticky({ children, btnStyle, ...props }: ContentRightSideStickyProps) {
    return (
        <div className="content__side-btn-sticky" {...props}>
            <div className="content__side-btn" style={btnStyle}>
                {children}
            </div>
        </div>
    );
}

export default ContentRightSideSticky;
